module.exports = __webpack_public_path__ + "img/sec2_09.936a8cdb.png";